import NewSlideshow from "../../classes/NewSlideshow";

export const initDocuments = () => {
	const documentsSections = document.querySelectorAll( 'section.documents.extensive' );

	if ( !documentsSections.length )
	{
		return;
	}

	Array.from( documentsSections ).forEach( ( it ) => {
		const tabs = it.querySelector( 'ul.tabs' );
		const container = it.querySelector( 'div.container' );
		const buttons = it.querySelector( 'ul.buttons' );
		const documentsList = container.querySelector( 'ul.documents' );
		let currentIndex = 0;
		let currentPosition = 0;

		Array.from( documentsList.children ).forEach( ( it ) => {
			it.classList.add( 'show' );
		} );

		const sliderInstance = new NewSlideshow( {
			element: it,
			autoWidth: true,
			hidingSlides: true
		} );

		sliderInstance.init();

		tabs.addEventListener( 'click', ( evt ) => {
			if ( evt.target.tagName.toLowerCase() !== 'button' )
			{
				return;
			}

			Array.from( tabs.querySelectorAll( 'button' ) ).forEach( ( it ) => {
				it.classList.remove( 'active' );
			} );

			evt.target.classList.add( 'active' );

			const requestedLine = evt.target.dataset.line;
			console.log(requestedLine);
			
			Array.from( documentsList.children ).forEach( ( it ) => {
				if ( requestedLine === 'all' || it.dataset.line === requestedLine )
				{
					it.classList.add( 'show' );
				}
				else
				{
					it.classList.remove( 'show' );
				}
			} );

			sliderInstance.updateSlides();
		} );
	} );
};
